import { render, staticRenderFns } from "./CustomerCrmOpportunityList.vue?vue&type=template&id=3910136c&scoped=true&"
import script from "./CustomerCrmOpportunityList.vue?vue&type=script&lang=js&"
export * from "./CustomerCrmOpportunityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3910136c",
  null
  
)

export default component.exports